






















import _ from 'lodash'
import Component, {mixins} from 'vue-class-component'
import StyleMixin from '@/modules/core/style/StyleMixin'
import {Prop, Inject} from 'vue-property-decorator';
import numeral from 'numeral'
import {ValueAccessor, ValueMutator} from '@/components/Form.vue'

/**
 * Campo de texto
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class TextField extends mixins(StyleMixin) {
    @Prop({type: [String, Number]})
    public value: any

    @Prop({type: String, default: ''})
    public label: string

    @Prop({type: String, default: ''})
    public prependIcon: string

    @Prop({type: String, default: ''})
    public prependInnerIcon: string

    @Prop({type: String, default: ''})
    public suffix: string

    @Prop({type: String, default: ''})
    public type: string

    @Prop({type: Array, default: () => []})
    public rules: Array<(v: string | any) => any>

    @Prop({type: [Number], required: false})
    public min: number

    @Prop({type: Boolean, required: false})
    public loading: number

    @Prop({type: Boolean, default: false})
    public readonly: boolean

    @Prop({type: Boolean, default: false})
    public dense: boolean

    /**
     * Si se declara, el campo hará un commit a la mutación especificada con
     * el valor del input
     */
    @Prop({type: String})
    public updateMutation: string

    @Prop({type: String, default: ''})
    public mutationFieldName: string

    @Inject({default: null})
    public readonly valueAccessor: ValueAccessor | null

    @Inject({default: null})
    public readonly valueMutator: ValueMutator | null

    @Prop({type: String, default: ''})
    public name: string

    @Prop({type: Boolean, default: false})
    public float: boolean

    @Prop({type: Boolean, default: false})
    public noForm: boolean

    @Prop({type: Boolean, default: false})
    public disabled: boolean

    @Prop({type: Number, default: 0})
    public debounce: number

    @Prop({type: [Number, String, Boolean], default: false})
    public counter: string | number | boolean

    @Prop({type: Boolean, default: false})
    public autofocus: boolean

    @Prop({type: String, default: ''})
    public autocomplete: string

    public get isNumber (): boolean {
        return this.type === 'number'
    }

    /**
     * Retorna el valor del campo
     *
     * Cuando el input forma parte de un formulario conectado con Vuex y dicho input
     * posee un nombre, se obtendrá el valor de dicho campo del objeto en Vuex
     */
    public get computedValue () {
        if (this.valueAccessor && this.name) {
            return this.valueAccessor(this.name)
        }

        return this.value
    }

    /**
     * Método ejecutado cuando el input se actualiza
     */
    public onInput (event: any) {
        // Si se ha inyectado desde el padre una función mutator, se utiliza esta
        const mutator = this.valueMutator
        const value = this.processValue(event)

        // Se actualiza el valor en el estado de Vuex
        if (mutator && this.name) {
            mutator({field: this.name, value})

            return
        }

        const updateMutation = this.updateMutation
        // Si se ha declarado una mutación, valor del input será enviado como payload
        // en el commit
        if (updateMutation) {
            this.$store.commit(
                updateMutation,
                this.mutationFieldName ? {field: this.mutationFieldName, value} : value,
            )
        }

        this.$emit('input', value)
    }

    /**
     * Procesa el valor si es necesario según el tipo del campo
     *
     * @param value
     */
    private processValue (value: any) {
        switch (true) {
            // El tipo del input es 'number' se parsea a entero o decimal según si se incluye
            // el atributo "float"
            case this.isNumber:
                const number = (numeral(value)).value()
                return _.isNull(number) || isNaN(number) ? 0 : number
            default:
                return value
        }
    }

    public get debouncedListener () {
        return _.debounce((event: any) => {
            this.onInput(event)
        }, this.debounce)
    }
}
